import React from 'react'
import {observer} from 'mobx-react'
import {DeliverToHomeIcon} from '../../../components/icons'
import {Box, Stack, Text} from '../../../vanilla'
import {useBasketStore} from '../../../store/hooks/useStore'

export const FreeDeliveryContainer = () => {
  const {deliveryPostalCode, isAppliedPostCodeDeliverable} = useBasketStore()

  return (
    <Box backgroundColor="white">
      <Text
        variant="heading1"
        paddingX="28px"
        paddingY="16px"
        borderBottom="1px"
        borderColor="gray200"
      >
        {`${deliveryPostalCode && !isAppliedPostCodeDeliverable ? 'Online' : 'Free'} delivery`}
      </Text>
      {deliveryPostalCode && !isAppliedPostCodeDeliverable ? (
        <Box paddingX="28px" paddingTop="16px" paddingBottom="28px">
          <Text variant="text3">
            We don’t deliver to your area yet, we’ll let you know when it becomes available.
          </Text>
        </Box>
      ) : (
        <Stack paddingX="28px" paddingTop="16px" paddingBottom="28px">
          <Text textAlign="center" variant="heading6">
            Free next day delivery
          </Text>
          <Text textAlign="center" variant="heading0">
            on all orders over{' '}
            <Text as="span" variant="unstyled" fontWeight="bold" fontSize="lg">
              £40
            </Text>
            .
          </Text>
          <DeliverToHomeIcon
            marginTop="8px"
            paddingX="24px"
            style={{width: '100%', height: '110px'}}
          />
        </Stack>
      )}
    </Box>
  )
}

export const FreeDelivery = observer(FreeDeliveryContainer)
